<template>
  <div class="container">
    <el-form ref="form" :model="form">
      <el-form-item label="标题">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <div class="part">门店信息</div>
      <div class="flex">
        <el-form-item label="今日课程">
          <el-input v-model.number="form.boardData.today_course"></el-input>
        </el-form-item>
        <el-form-item label="今日已上">
          <el-input v-model.number="form.boardData.today_course_end"></el-input>
        </el-form-item>
        <el-form-item label="今日学员">
          <el-input v-model.number="form.boardData.today_stu"></el-input>
        </el-form-item>
        <el-form-item label="本月课程">
          <el-input v-model.number="form.boardData.month_course"></el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="今日收益">
          <el-input v-model.number="form.boardData.today_income"></el-input>
        </el-form-item>
        <el-form-item label="本月收益">
          <el-input v-model.number="form.boardData.month_income"></el-input>
        </el-form-item>
        <el-form-item label="累计收益">
          <el-input v-model.number="form.boardData.total_income"></el-input>
        </el-form-item>
      </div>
      <div class="part">本月收益情况</div>
      <i
        class="el-icon-plus"
        @click="form.incomeEData.push({ value: '', time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.incomeEData" :key="i + 'd'">
        <el-input placeholder="当天收益" v-model="n.value">
          <template slot="prepend">金额</template>
        </el-input>
        <el-input placeholder="07-01" v-model="n.time">
          <template slot="prepend">时间</template>
        </el-input>
        <i class="el-icon-delete" @click="form.incomeEData.splice(i, 1)"></i>
      </div>

      <div class="part">本月课程数量情况</div>
      <i
        class="el-icon-plus"
        @click="form.courseNumEData.push({ value: '', time: '' })"
      ></i>
      <div
        class="grid-box"
        v-for="(n, i) in form.courseNumEData"
        :key="i + 'i'"
      >
        <el-input placeholder="当天课节数" v-model="n.value">
          <template slot="prepend">人数</template>
        </el-input>
        <el-input placeholder="07-01" v-model="n.time">
          <template slot="prepend">时间</template>
        </el-input>
        <i class="el-icon-delete" @click="form.courseNumEData.splice(i, 1)"></i>
      </div>

      <div class="part">学员人数情况</div>
      <i
        class="el-icon-plus"
        @click="form.personEData.push({ value: '', time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.personEData" :key="i + 'p'">
        <el-input placeholder="当天学员数" v-model="n.value">
          <template slot="prepend">人数</template>
        </el-input>
        <el-input placeholder="07-01" v-model="n.time">
          <template slot="prepend">时间</template>
        </el-input>
        <i class="el-icon-delete" @click="form.personEData.splice(i, 1)"></i>
      </div>

      <div class="part">课程类目数量情况</div>
      <i
        class="el-icon-plus"
        @click="form.courseCategoryEData.push({ value: '', name: '' })"
      ></i>
      <div
        class="grid-box"
        v-for="(n, i) in form.courseCategoryEData"
        :key="i + 'c'"
      >
        <el-input placeholder="数量" v-model="n.value">
          <template slot="prepend">课节数</template>
        </el-input>
        <el-input placeholder="篮球，游泳..." v-model="n.name">
          <template slot="prepend">类目</template>
        </el-input>
        <i
          class="el-icon-delete"
          @click="form.courseCategoryEData.splice(i, 1)"
        ></i>
      </div>

      <div class="part">门店本月数据</div>
      <i
        class="el-icon-plus"
        @click="
          form.mecDatas.push({ mechanism_name: '', cash: '', person_count: '',course_count:'' })
        "
      ></i>
      <div class="grid-box" v-for="(n, i) in form.mecDatas" :key="i + 'm'">
        <el-input placeholder="机构名称" v-model="n.mechanism_name">
          <template slot="prepend">机构名称</template>
        </el-input>
        <el-input placeholder="机构收益" v-model="n.cash">
          <template slot="prepend">机构收益</template>
        </el-input>
        <el-input placeholder="学员数量" v-model="n.person_count">
          <template slot="prepend">学员数量</template>
        </el-input>
         <el-input placeholder="课程数量" v-model="n.course_count">
          <template slot="prepend">课程数量</template>
        </el-input>
        <i class="el-icon-delete" @click="form.mecDatas.splice(i, 1)"></i>
      </div>

      <div class="part">今日学员</div>
      <i
        class="el-icon-plus"
        @click="form.students.push({ name: '', title: '', start_time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.students" :key="i + 'st'">
        <el-input placeholder="学员名称" v-model="n.name">
          <template slot="prepend">学员名称</template>
        </el-input>
        <el-input placeholder="课程名称" v-model="n.title">
          <template slot="prepend">课程名称</template>
        </el-input>
        <el-time-select
          v-model="n.start_time"
          :picker-options="{
            start: '06:00',
            step: '01:00',
            end: '23:00',
          }"
          placeholder="选择时间"
        >
        </el-time-select>
        <i class="el-icon-delete" @click="form.students.splice(i, 1)"></i>
      </div>

      <div class="part">今日课程表</div>
      <i
        class="el-icon-plus"
        @click="
          form.courseList.push({
            group_name: '',
            title: '',
            start_time: '',
            end_time: '',
          })
        "
      ></i>
      <div class="grid-box" v-for="(n, i) in form.courseList" :key="i + 'ct'">
        <el-input placeholder="机构名称" v-model="n.group_name">
          <template slot="prepend">机构名称</template>
        </el-input>
        <el-input placeholder="课程名称" v-model="n.title">
          <template slot="prepend">课程名称</template>
        </el-input>
        <el-time-select
          v-model="n.start_time"
          :picker-options="{
            start: '06:00',
            step: '01:00',
            end: '23:00',
          }"
          placeholder="开始时间"
        >
        </el-time-select>
        <el-time-select
          v-model="n.end_time"
          :picker-options="{
            start: '06:00',
            step: '01:00',
            end: '23:00',
          }"
          placeholder="结束时间"
        >
        </el-time-select>
        <i class="el-icon-delete" @click="form.courseList.splice(i, 1)"></i>
      </div>

      <div class="m-t20">
        <el-button v-if="id" type="success" @click="update">修改数据</el-button>
        <el-button v-else type="warning" @click="add">新增数据</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      time: "",
      city: "杭州市",
      count: 0,
      count2: 0,
      hour: "",
      name: "",
      pic: "",
      form: {
        name: "",
        boardData: {},
        incomeEData: [],
        courseNumEData: [],
        courseCategoryEData: [],
        personEData: [],
        mecDatas: [],
        courseList: [],
        students: [],
      },
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },

  methods: {
    getInfo() {
      this.$axios({
        url: "/user/sysParam/findById",
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        let v = res.data.data;
        this.form = {...this.form,...JSON.parse(v.param_value)} 
        this.pic = this.form.pic;
        this.city = v.remark;
        this.time = v.update_time.split(" ")[0];
        
      });
    },
    closeTag(v, i) {
      this.form[v].splice(i, 1);
    },
    addBar(v) {
      this.form[v].push({
        value: Number(this.count),
        name: this.name,
      });
    },
    addToday(v) {
      this.form[v].push({
        hour: this.hour,
        count: Number(this.count),
        count2: Number(this.count2),
      });
    },
    update() {
      this.$axios({
        url: "/user/sysParam/update",
        method: "post",
        data: {
          id: this.id,
          param_key: "mall_income",
          param_value: JSON.stringify(this.form),
          type: "mallData",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
    add() {
      this.$axios({
        url: "/user/sysParam/insert",
        method: "post",
        data: {
          param_key: "mall_income",
          param_value: JSON.stringify(this.form),
          type: "mallData",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.part {
  font-size: 16px;
  height: 30px;
  font-weight: 600;
  margin-top: 20px;
  border-top: 1px solid rgb(214, 214, 214);
}
</style>